// classes and types
import type { BackendCompletedForm } from '../../../../Typescript/backend/classes';
import { sortByInternalName } from '../../../PolicyStream/PolicyStreamReviewPage/utility';

export const sortAxisForms = (forms: Array<BackendCompletedForm>) => {
  const internalNameForms = forms.filter((form) => form.internalName);
  const otherForms = forms.filter((form) => !form.internalName);

  const sortedInternalNameForms = [...internalNameForms].sort((a, b) =>
    sortByInternalName(a, b),
  );

  const generalInformation = otherForms.filter((form) => form.policy === null);

  const policyForms = otherForms
    .filter((form) => form.policy !== null)
    .sort((a, b) =>
      a.policy && b.policy
        ? a.policy.displayName.localeCompare(b.policy.displayName)
        : 0,
    );

  return [...sortedInternalNameForms, ...generalInformation, ...policyForms];
};

export const sortForms = (forms: Array<BackendCompletedForm>) => {
  const generalInformation = forms.filter((form) => form.policy === null);

  const generalLiablility = forms.filter(
    (form) => form.policy?.displayName === 'General Liability',
  );
  const property = forms.filter(
    (form) => form.policy?.displayName === 'Property',
  );
  const formsFound = [...generalInformation, ...generalLiablility, ...property];
  const otherForms = forms
    .filter(
      (form) =>
        formsFound.find((innerForm) => form === innerForm) === undefined,
    )
    .sort((a, b) =>
      a.policy && b.policy
        ? a.policy.displayName.localeCompare(b.policy.displayName)
        : 0,
    );

  return [...formsFound, ...otherForms];
};
